import React from "react";
import { Payment, Transaction } from "./interface";
import dollarIcon from "@/assets/icons/dollarIcon.svg";
import { format } from "date-fns";
import { FaCircleCheck } from "react-icons/fa6";
import { MdOutlinePending } from "react-icons/md";
import {
  convertCentsToDollars,
  Loader,
  USFormatePriceWithDecimal,
} from "@thdinc/hpf-shared";

interface PaymentComp {
  payments: Payment[];
  openModal: () => void;
  openTransModal: () => void;
  selectCurrentPayment: (paymentId: string) => void;
  // selectCurrentTrans:(transaction:Transaction[])=>void
}
const PaymentsTable: React.FC<PaymentComp> = ({
  payments,
  selectCurrentPayment,
  openModal,
  openTransModal,
}) => {
  console.log("payments", payments[0]);
  return (
    <div>
      <div className="relative overflow-x-auto  rounded-2xl mt-4 overflow-y-auto max-h-full ">
        <table className="w-full text-sm text-left rtl:text-right text-gray-500">
          <thead className="text-xs text-gray-700 uppercase bg-[#fcfdfd]">
            <tr>
              <th scope="col" className=" sm:px-3 py-4 uppercase text-center">
                Customer Name
              </th>
              <th scope="col" className=" sm:px-2  py-4 uppercase text-center">
                Business Name
              </th>
              {/* <th scope="col" className=" sm:px-5  py-4 uppercase">
                Package Name
              </th> */}
              <th scope="col" className=" sm:px-2  py-4 uppercase text-center">
                First Payment
              </th>{" "}
              <th scope="col" className=" sm:px-2  py-4 uppercase text-center">
                Second Payment
              </th>{" "}
              <th scope="col" className=" sm:px-2  py-4 uppercase text-center">
                Alcohol Charge
              </th>
              <th scope="col" className=" sm:px-2  py-4 uppercase text-center">
                Event Date
              </th>
              <th scope="col" className=" sm:px-2  py-4 uppercase text-center">
                Booking Amount
              </th>
              <th scope="col" className=" sm:px-2  py-4 uppercase text-center">
                Transactions
              </th>
              <th scope="col" className=" sm:px-3  py-4 text-center">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {payments.map((item: Payment, index) => {
              return (
                <tr key={index} className="bg-white 0  border-b">
                  <td className="sm:px-3 py-4 min-w-32 text-center">
                    {/* <img className="h-14 w-14 object-cover rounded-full " src={item.image} /> */}
                    {`${item?.first_name} ${item.last_name}`}
                  </td>
                  <td className="sm:px-2 py-4 min-w-32 text-center">
                    <p>{item.business_name}</p>
                  </td>
                  {/* <td className="px-2 sm:px-4 py-4 text-sm min-w-36">
                    <p>{item.package_name}</p>
                  </td> */}
                  <td className=" sm:px-2 py-4 min-w-32 text-center">
                    <p className="">
                      <FaCircleCheck
                        size={17}
                        className="text-green-600 mx-auto"
                      />
                    </p>
                  </td>
                  <td className="sm:px-2 py-2 min-w-32">
                    <p className={`text-center  font-bol`}>
                      {item.pending_amount === 0 &&
                        item.payment_type === "full" && (
                          <FaCircleCheck
                            size={17}
                            className=" mx-auto"
                            title="Full Payment Booking"
                          />
                        )}
                      {item.pending_amount > 0 &&
                        item.payment_type === "half" && (
                          <MdOutlinePending
                            size={21}
                            title="Not Due"
                            className={`${"text-green-600 mx-auto"}`}
                          />
                        )}
                      {item.pending_amount > 0 &&
                        item.payment_type === "offline" && (
                          <FaCircleCheck
                            size={17}
                            title="Declined"
                            className={`${"text-red-600 mx-auto"}`}
                          />
                        )}
                      {item.pending_amount > 0 &&
                        item.payment_type === "full" && (
                          <FaCircleCheck
                            size={17}
                            title="Paid"
                            className=" mx-auto text-green-600"
                          />
                        )}
                    </p>
                  </td>
                  <td className=" sm:px-2 py-2 min-w-32">
                    <p className="text-center">
                      {/* If payment is done */}
                      {item.package_type == "custom_package" ? (
                        <FaCircleCheck
                          size={17}
                          className=" mx-auto"
                          title="Custom Package Booking"
                        />
                      ) : item.product_total == 0 ? (
                        <FaCircleCheck
                          size={17}
                          className=" mx-auto"
                          title="No Product Booking"
                        />
                      ) : item.product_total_status === "confirmed" ? (
                        <FaCircleCheck
                          size={17}
                          title="Paid"
                          className="text-green-600 mx-auto  "
                        />
                      ) : item.product_total_status === "declined" ? (
                        <FaCircleCheck
                          size={17}
                          title="Declined"
                          className="text-red-600  mx-auto  "
                        />
                      ) : item.product_total_status === "pending" &&
                        greaterThanCurrentDate(item.event_date) ? (
                        <MdOutlinePending
                          size={21}
                          title="Over Due"
                          className={`${"text-red-600 mx-auto "}`}
                        />
                      ) : (
                        <MdOutlinePending
                          size={21}
                          title="Not Due"
                          className={`${"text-green-600 mx-auto "}`}
                        />
                      )}
                    </p>
                  </td>

                  <td className="sm:px-4 py-4  min-w-32">
                    {format(new Date(item.event_date), "MM-dd-yyyy")}
                  </td>

                  <td className=" sm:px-4 py-4  min-w-32">
                    <p className="text-center">
                      $
                      {USFormatePriceWithDecimal(
                        convertCentsToDollars(
                          (item.service_total - item.discount_total).toString()
                        )
                      )}
                    </p>
                  </td>
                  <td className=" sm:px-4 py-4  w-full  gap-8 flex items-center  justify-center  ">
                    {parseInt(item.transactions) !== 0 ? (
                      <div
                        onClick={() => {
                          openTransModal();
                          selectCurrentPayment(item.id);
                        }}
                        className="rounded-2xl py-2 px-4 bg-p-gray cursor-pointer"
                      >
                        {item.transactions}
                      </div>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td className="sm:px-4 py-4">
                    {/* <img className="h-14 w-14 object-cover rounded-full " src={item.image} /> */}
                    <img
                      onClick={() => {
                        selectCurrentPayment(item.id);
                        openModal();
                      }}
                      src={dollarIcon}
                      alt="dollar"
                      className="w-6 cursor-pointer"
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PaymentsTable;

// if current date is bigger than given date return false
function greaterThanCurrentDate(passedDate: string) {
  const currentDate = new Date(); // Get the current date and time
  const comparisonDate = new Date(passedDate); // Convert the passed date to a Date object

  return comparisonDate < currentDate; // Return true if the passed date is in the future
}
